import React from 'react';
import '../styles/FilterSidebar.css';

const FilterSidebar = ({ categories, selectedCategory, onCategoryChange }) => {
  return (
    <div className="filter-sidebar">
      <h3>Categorías</h3>
      <div className="categories-list">
        {categories.map(category => (
          <button
            key={category}
            className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterSidebar;